import { render, staticRenderFns } from "./BackTest.vue?vue&type=template&id=b7c31d8c&scoped=true&"
import script from "./BackTest.vue?vue&type=script&lang=js&"
export * from "./BackTest.vue?vue&type=script&lang=js&"
import style0 from "./BackTest.vue?vue&type=style&index=0&id=b7c31d8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c31d8c",
  null
  
)

export default component.exports